class Scrollspy {
  constructor(onSectionsUpdate) {
    this.onSectionsUpdate = onSectionsUpdate;
    this.sections = [];
    this.scrollspyList = null;
    this.sectionWrappers = [];
    this.sectionIdToIndex = new Map();
    this.scrollRaf = null;
    this.activeId = null;
    this.activeIndex = 0;
    this.boundaryHysteresisPx = 8;
    this.pendingIndex = null;
    this.pendingCount = 0;
    this.switchFrames = 2;
    this.lockActiveUntil = 0;
    this.lockedActiveId = null;

    this.onScroll = this.onScroll.bind(this);
    this.onListClick = this.onListClick.bind(this);
    this.onResize = this.onResize.bind(this);

    this.init();
  }

  init() {
    if (!document.querySelector(".startpage")) return;

    const scrollSpyTitles = document.querySelectorAll(".scrollspy-title");
    const scrollspyList = document.querySelector(".scrollspy-list");

    if (!scrollspyList) return;

    this.scrollspyList = scrollspyList;
    this.sectionWrappers = [];
    this.sections = [];
    this.sectionIdToIndex = new Map();
    this.activeId = null;
    this.activeIndex = 0;
    this.pendingIndex = null;
    this.pendingCount = 0;

    scrollspyList.innerHTML = "";

    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
    this.scrollspyList.removeEventListener("click", this.onListClick);

    scrollSpyTitles.forEach((item, i) => {
      const wrapper = item.closest(".scrollspy-container-wrapper");
      if (!wrapper) return;

      const li = document.createElement("li");
      const a = document.createElement("a");

      const sectionId = `section-${i + 1}`;
      wrapper.id = sectionId;

      a.href = `#${sectionId}`;
      a.innerHTML = i + 1;
      a.classList.add(sectionId);
      a.dataset.hover = item.innerHTML || "";

      li.appendChild(a);
      scrollspyList.appendChild(li);

      this.sectionWrappers.push(wrapper);
      this.sectionIdToIndex.set(sectionId, i);
      this.sections.push({ id: sectionId, title: item.innerHTML || "" });
    });

    this.scrollspyList.addEventListener("click", this.onListClick);
    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onResize, { passive: true });

    this.updateActive();

    if (typeof this.onSectionsUpdate === "function") {
      this.onSectionsUpdate(this.sections);
    }
  }

  onListClick(e) {
    const anchor = e.target.closest("a[href^='#']");
    if (!anchor || !this.scrollspyList.contains(anchor)) return;

    e.preventDefault();
    const targetId = anchor.getAttribute("href").substring(1);
    const targetSection = document.getElementById(targetId);
    if (!targetSection) return;

    this.setActiveById(targetId);
    this.lockedActiveId = targetId;
    this.lockActiveUntil = performance.now() + 450;

    window.scrollTo({
      top: targetSection.offsetTop,
      behavior: "smooth"
    });
  }

  onScroll() {
    if (this.scrollRaf) return;
    this.scrollRaf = window.requestAnimationFrame(() => {
      this.scrollRaf = null;
      this.updateActive();
    });
  }

  onResize() {
    this.onScroll();
  }

  updateActive() {
    if (!this.sectionWrappers.length || !this.scrollspyList) return;

    if (this.lockedActiveId && performance.now() < this.lockActiveUntil) {
      this.setActiveById(this.lockedActiveId);
      return;
    }

    this.lockedActiveId = null;

    const header = document.querySelector(".iz-header");
    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    const triggerLineY = window.scrollY + headerHeight + 16;
    const tops = this.sectionWrappers.map((wrapper) => {
      const rect = wrapper.getBoundingClientRect();
      return rect.top + window.scrollY;
    });

    if (this.activeId === null) {
      let initialIndex = 0;
      for (let i = 0; i < tops.length; i += 1) {
        if (tops[i] <= triggerLineY) {
          initialIndex = i;
        } else {
          break;
        }
      }
      this.activeIndex = initialIndex;
      this.setActiveById(this.sectionWrappers[initialIndex].id);
      return;
    }

    let candidateIndex = 0;
    for (let i = 0; i < tops.length; i += 1) {
      if (tops[i] <= triggerLineY + this.boundaryHysteresisPx) {
        candidateIndex = i;
      } else {
        break;
      }
    }

    if (candidateIndex === this.activeIndex) {
      this.pendingIndex = null;
      this.pendingCount = 0;
      return;
    }

    if (this.pendingIndex !== candidateIndex) {
      this.pendingIndex = candidateIndex;
      this.pendingCount = 1;
      return;
    }

    this.pendingCount += 1;
    if (this.pendingCount < this.switchFrames) return;

    this.pendingIndex = null;
    this.pendingCount = 0;
    this.activeIndex = candidateIndex;
    this.setActiveById(this.sectionWrappers[candidateIndex].id);
  }

  setActiveById(activeId) {
    if (this.activeId === activeId) return;

    this.activeId = activeId;
    if (this.sectionIdToIndex.has(activeId)) {
      this.activeIndex = this.sectionIdToIndex.get(activeId);
    }

    this.scrollspyList.querySelectorAll("li a").forEach((el) => {
      el.classList.toggle("active", el.classList.contains(activeId));
    });
  }
}

export default Scrollspy;




